import { EventType } from 'matrix-js-sdk';

export const CALL_WIDGET_ID = 'call-embed';

export const CALL_WIDGET_PATH = '/element-call/index.html';

export const CALL_SOUND_PATH = '/sound/call.ogg';

/** Room events the call widget may send and receive. */
export const CALL_ROOM_EVENT_CAPABILITY_TYPES = [
	'io.element.call.encryption_keys',
	'org.matrix.rageshake_request',
	EventType.Reaction,
	EventType.RoomRedaction,
	'io.element.call.reaction',
	'org.matrix.msc4075.rtc.notification',
	'org.matrix.msc4310.rtc.decline'
];

/** To-device events the call widget may send and receive. */
export const CALL_TO_DEVICE_CAPABILITY_TYPES = [
	EventType.CallInvite,
	EventType.CallCandidates,
	EventType.CallAnswer,
	EventType.CallHangup,
	EventType.CallReject,
	EventType.CallSelectAnswer,
	EventType.CallNegotiate,
	EventType.CallSDPStreamMetadataChanged,
	EventType.CallSDPStreamMetadataChangedPrefix,
	EventType.CallReplaces,
	EventType.CallEncryptionKeysPrefix
];

/** Timeline events older than this many events are assumed to have been seen by the widget. */
export const CALL_READ_UP_TO_SEARCH_LIMIT = 100;

/** Below this control-bar width the in-call controls stack into two rows. */
export const CALL_CONTROLS_COMPACT_WIDTH = 500;

export const CALL_PRESCREEN_MEMBERS_MAX = 4;

export const CALL_GLANCE_MEMBERS_MAX = 6;

export const CALL_SPEAKING_NAMES_MAX = 3;

/** An `m.rtc.notification` whose `sender_ts` is further off than this falls back to the event ts. */
export const CALL_NOTIFICATION_TS_DRIFT_MS = 20000;

export const CALL_NOTIFICATION_MAX_LIFETIME_MS = 120000;

/** Cinny's call control buttons use a longer tooltip delay than the app default. */
export const CALL_CONTROLS_TOOLTIP_DELAY_MS = 500;
